/* eslint-disable react-hooks/exhaustive-deps */

import { ActionTaskList } from "pages/Task/types"
import { useEffect, useState } from "react"
import { SuccessFetch } from "types"
import { useApi } from "utils"

type Response = {
  payload: ActionTaskList[]
}

export function useActionTaskList() {
  const api = useApi()
  const [data, setData] = useState<ActionTaskList[]>([])
  const [isLoading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)

    api
      .get("/action-task/")
      .then((res: SuccessFetch<Response>) => {
        const data = res.data.payload ?? []
        setData(data)
      })
      .catch(() => setData([]))
      .finally(() => setLoading(false))
  }

  const refetch = () => fetchData()

  useEffect(() => {
    fetchData()

    return () => {
      setData([])
      setLoading(false)
    }
  }, [])

  return {
    data,
    isLoading,
    refetch,
    dropdown: data.map((item) => ({
      value: item.mr_action_task_id?.toString(),
      label: item.mr_action_task_name
    }))
  }
}
